/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export enum ThreatVulnerabilitiesFiltersRequestSortColumn {
    resource = 'resource',
    severity = 'severity',
    service_name = 'service_name',
    status = 'status',
    findings_id = 'findings_id',
    resource_id = 'resource_id',
    resource_name = 'resource_name'
}
